import {
  AccountSetupOnboardingStep,
  AccountSetupVariant,
  OnboardingStep,
  OnboardingStepsBuilderParams,
  SupportedInstallationScenario
} from './types';

const getAccountSetupVariant = (
  hasOrganization: boolean,
  isEmailVerified: boolean
): AccountSetupVariant | null => {
  if (!isEmailVerified && !hasOrganization) return 'EMAIL_AND_ORGANIZATION';
  if (!isEmailVerified) return 'EMAIL';
  if (!hasOrganization) return 'ORGANIZATION';

  return null;
};

const isSupportedInstallationScenario = (
  scenario: OnboardingStepsBuilderParams['pwaInstallationScenario']
): scenario is SupportedInstallationScenario => {
  return scenario === 'NATIVE' || scenario === 'SAFARI_IOS' || scenario === 'SAFARI_MACOS';
};

export const buildOnboardingSteps = (
  params: OnboardingStepsBuilderParams
): readonly OnboardingStep[] => {
  const {
    hasOrganization,
    isEmailVerified,
    pwaInstallationScenario
  } = params;
  const steps: OnboardingStep[] = [];
  const accountSetupVariant = getAccountSetupVariant(hasOrganization, isEmailVerified);

  if (accountSetupVariant) {
    const accountSetupStep: AccountSetupOnboardingStep = {
      id: 'ACCOUNT_SETUP',
      variant: accountSetupVariant
    };

    steps.push(accountSetupStep);
  }

  steps.push({ id: 'CREATE_SHIPMENT' });
  steps.push({ id: 'SUPPORT_OPERATOR' });

  if (isSupportedInstallationScenario(pwaInstallationScenario)) {
    steps.push({
      id: 'INSTALL_APPLICATION',
      scenario: pwaInstallationScenario
    });
  }

  return Object.freeze(steps.map((step) => Object.freeze(step)));
};